import React, { useState, useRef } from "react";
import ReactCrop from "react-image-crop";
import Modal from "react-modal";
import Button from "../buttons/Button";

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: 50,
  },
  content: {
    background: "transparent",
    border: "none",
    overflow: "hidden",
    inset: 0,
    top: 0,
    bottom: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const ImageCrop = ({
  src,
  onCrop,
  ratio = 1,
  show,
  setShow,
  square = false,
}) => {
  const [crop, setCrop] = useState({
    aspect: ratio,
    width: 50,
    x: 25,
    y: 5,
    unit: "%",
    locked: true,
  });
  const imageRef = useRef();

  const onImageLoaded = image => {
    imageRef.current = image;
  };

  const getCroppedImage = () => {
    const canvas = document.createElement("canvas");
    const image = imageRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(crop.width * scaleX);
    canvas.height = Math.ceil(crop.height * scaleY);
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    canvas.toBlob(blob => {
      if (!blob) {
        console.error("Canvas is empty");
        return;
      }
      blob.name = "CroppedImage.jpeg";
      const fileUrl = window.URL.createObjectURL(blob);
      const file = new File([blob], "cropped.jpeg", {
        type: "image/jpeg",
      });
      onCrop(file, fileUrl);
    }, "image/jpeg");
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={() => setShow(false)}
      style={modalStyles}
      className="imageUpload_modal"
    >
      <div className="imageUpload_cropper">
        <ReactCrop
          src={src}
          crop={crop}
          onImageLoaded={onImageLoaded}
          onChange={newCrop => setCrop(newCrop)}
          circularCrop={!square}
          keepSelection
        />
        <Button onClick={getCroppedImage}>Crop image</Button>
      </div>
    </Modal>
  );
};

export default ImageCrop;
